// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2L7Ur","question":"styles_question__SBRsS","inputVisibleButton":"styles_inputVisibleButton__3WWJu","note":"styles_note__3C9fs"};